import { ARCHETYPES, REGROUPER } from '../data/archetypes.js';
import { SECTOR, SIZE, SECTOR_SIGNATURE } from '../data/sectorSize.js';

export function buildReport({ result, sector, size, expFollowup, regrouperConfirmed }) {
  const sCtx = {
    sector: SECTOR[sector] || SECTOR.other,
    size: SIZE[size] || SIZE.mid
  };

  const isRegrouper = result.posture === "regrouper" &&
    (result.postureSource === "self" || regrouperConfirmed === true);

  let A, heading, teaser, signalNote, couldBe, themesHeading, cta, underlyingName;

  if (isRegrouper) {
    A = REGROUPER;
    underlyingName = ARCHETYPES[result.base]?.name || "an Experimenter";
    heading = result.postureSource === "self" ? A.headingSelf : A.headingInferred;
    teaser = result.postureSource === "self" ? A.teaserSelf : A.teaserInferred;
    signalNote = A.signalNote(underlyingName);
    couldBe = A.couldBe(sCtx);
    themesHeading = A.themesHeading;
    cta = A.cta;
  } else {
    A = ARCHETYPES[result.base];
    heading = A.heading;
    teaser = A.teaser;
    signalNote = A.signalNote;
    couldBe = A.couldBe(sCtx);
    themesHeading = A.themesHeading;
    cta = A.cta;
  }

  // Assemble themes
  let themes = A.themes.map((t) => ({ ...t }));

  // Experimenter/scaler _lead replacement by follow-up
  if (result.base === "experimenter" && !isRegrouper) {
    if (expFollowup === "misaimed") {
      themes[0] = {
        dim: "_lead",
        title: "Pressure-test your direction before you invest further",
        body: "Your effort is concentrated, which is good, but the risk is pouring more into a bet that hasn't been validated against what AI can realistically do. Before scaling, it's worth stress-testing whether the direction is the right one, leaning on real evidence rather than conviction."
      };
    }
    // hybrid keeps consolidation lead, validation becomes theme 2 emphasis
  }

  // Sector signature theme (conditional on its dim scoring low)
  const sig = SECTOR_SIGNATURE[sector];
  if (sig && (result.c[sig.dim] || 0) < 3 && !themes.some((t) => t.title === sig.title)) {
    themes.push({ ...sig });
  }

  // Capacity gate: insert unblock-first lead
  if (result.flag === "blocked") {
    themes.unshift({
      dim: "capacity",
      title: "Before anything else, make space for this to happen",
      body: `Your answers suggest the real bottleneck isn't knowledge or readiness, it's bandwidth. On paper you may be well placed, but none of it moves until someone has the time to lead it. The first step is deciding who owns this and what comes off their plate. For a ${sCtx.size.name} organisation that usually means ${sCtx.size.scale}. It may even be that the honest advice is to sort this internally first, then talk to someone. Everything else waits on it.`,
    });
  }

  // Cap themes: 3 to 5 (primed stays at its 3)
  if (result.base !== "primed") {
    themes = themes.slice(0, 5);
  }

  return {
    isRegrouper,
    heading,
    teaser,
    signalNote,
    couldBe,
    themesHeading,
    themes,
    cta,
    underlyingName
  };
}
